import googleCalendarImage from '../../../../assets/icons/google/google-calendar.png';
export const CALENDAR_PROVIDERS = {
    GOOGLE_CALENDAR: {
        name: 'Google Calendar',
        icon: <img src={googleCalendarImage} alt="loader" width={48} height={48} />,
        // icon: <img src="/images/google.svg" alt="loader" width={48} height={48} />,
    },
    OUTLOOK_CALENDAR: {
        name: 'Outlook Calendar',
        icon: <img src="/images/outlook.svg" alt="loader" width={48} height={48} />,
    },
};
